/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Sonstige19Inputs */

const en__field_enum_csjensblank_sonstige19 = /** @type {(inputs: _Field_Enum_Csjensblank_Sonstige19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de__field_enum_csjensblank_sonstige19 = /** @type {(inputs: _Field_Enum_Csjensblank_Sonstige19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {_Field_Enum_Csjensblank_Sonstige19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_sonstige19 = /** @type {((inputs?: _Field_Enum_Csjensblank_Sonstige19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Sonstige19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_sonstige19(inputs)
	return de__field_enum_csjensblank_sonstige19(inputs)
});
export { _field_enum_csjensblank_sonstige19 as "_field_enum_CSJENSBLANK_SONSTIGE" }